"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.user = user;

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var INITIAL_STATE = {
  userId: 0,
  email: '',
  firstName: '',
  lastName: '',
  fullName: '',
  locale: 'en-us',
  roles: []
};

function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.SET_USER:
      return Object.assign({}, state, action.user);

    default:
      return state;
  }
}